const { REACT_APP_USER_EVENTS_HOST } = process.env;

const baseUrl =
  REACT_APP_USER_EVENTS_HOST ?? 'https://user-events-staging.junilearning.com';

export default baseUrl;
